export default __webpack_public_path__ + "static/media/icon_zoomselect.976076d1.png";